<div style="position: relative">
  <div
    class="avatar-container"
    style="--size: {{ size }}px;"
    [class.animate]="animateAvatarChange">
    <div class="avatar">
      <div class="avatar-front">
        <div *ngIf="shouldAnimate; else normalFront">
          <div *ngIf="previousImage; else fallbackImage">
            <div class="image-container" style="--size: {{ size }}px;">
              <img [src]="previousImage" class="image" />
            </div>
          </div>
          <ng-template #fallbackImage>
            <div
              *ngIf="!previousName && defaultIcon"
              class="fallback-image fallback-icon"
              style="--size: {{ size }}px; --color: {{ '#CCC' }}">
              <mat-icon [svgIcon]="defaultIcon"></mat-icon>
            </div>
            <div
              *ngIf="previousName && previousName.length > 0"
              class="fallback-image"
              style="--size: {{ size }}px; --color: {{ previousColor }}">
              <span class="text-trim">
                {{ getInitials(previousName) | uppercase }}
              </span>
            </div>
          </ng-template>
        </div>
        <ng-template #normalFront>
          <div *ngIf="image; else fallbackImageNormal">
            <div class="image-container" style="--size: {{ size }}px;">
              <img [src]="image" class="image" />
            </div>
          </div>
          <ng-template #fallbackImageNormal>
            <div
              *ngIf="!name && defaultIcon"
              class="fallback-image fallback-icon"
              style="--size: {{ size }}px; --color: {{ '#CCC' }}">
              <mat-icon [svgIcon]="defaultIcon"></mat-icon>
            </div>
            <div
              *ngIf="name && name.length > 0"
              class="fallback-image"
              style="--size: {{ size }}px; --color: {{ color }}">
              <span class="text-trim">
                {{ getInitials(name) | uppercase }}
              </span>
            </div>
          </ng-template>
        </ng-template>
      </div>
      <div class="avatar-back">
        <div *ngIf="image; else fallbackImageBack">
          <div class="image-container" style="--size: {{ size }}px;">
            <img [src]="image" class="image" />
          </div>
        </div>
        <ng-template #fallbackImageBack>
          <div
            *ngIf="!name && defaultIcon"
            class="fallback-image fallback-icon"
            style="--size: {{ size }}px; --color: {{ '#CCC' }}">
            <mat-icon [svgIcon]="defaultIcon"></mat-icon>
          </div>
          <div
            *ngIf="name && name.length > 0"
            class="fallback-image"
            style="--size: {{ size }}px; --color: {{ color }}">
            <span class="text-trim">{{ getInitials(name) | uppercase }}</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <button
    class="add-photo-button avatar-button"
    *ngIf="showImageButton && canEdit"
    (click)="triggerFileInput()">
    <mat-icon svgIcon="add-photo-icon"></mat-icon>
  </button>
  <button
    class="palette-button avatar-button"
    (click)="openColorSelectionModal()"
    *ngIf="showPaletteButton && !image && canEdit">
    <mat-icon svgIcon="palette-icon"></mat-icon>
  </button>
  <button
    class="remove-photo-button avatar-button"
    *ngIf="showImageButton && image && canEdit"
    (click)="removePhoto()">
    <mat-icon svgIcon="trash-icon" class="trash-icon"></mat-icon>
  </button>
  <mat-icon
    *ngIf="showIsFavourite"
    [svgIcon]="'heart-icon'"
    class="heart-icon"></mat-icon>
  <input
    type="file"
    #fileInput
    accept="image/*"
    style="display: none"
    (change)="onFileSelected($event)" />
</div>
